import { Platform } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';
import type { IPlatformDictionaryItem } from '@/types/dictionary';

export const platformDictionary = createSimpleDictionary<IPlatformDictionaryItem>(
    [
        { id: Platform.Tradeball, name: 'dictionaries.platform.tradeball', isActive: 1 },
        { id: Platform.Betbra, name: 'dictionaries.platform.betbra', isActive: 1 },
        { id: Platform.Apostasnow, name: 'dictionaries.platform.apostasnow', isActive: 0 },
        { id: Platform.Apostasbf, name: 'dictionaries.platform.apostasbf', isActive: 0 },
        { id: Platform.Drinbet, name: 'dictionaries.platform.drinbet', isActive: 0 },
        { id: Platform.Bolsadeaposta, name: 'dictionaries.platform.bolsadeaposta', isActive: 1 },
        { id: Platform.Greenwin, name: 'dictionaries.platform.greenwin', isActive: 0 },
        { id: Platform.Betbox, name: 'dictionaries.platform.betbox', isActive: 0 },
        { id: Platform.Fulltbet, name: 'dictionaries.platform.fulltbet', isActive: 1 },
        { id: Platform.Verdinhabet, name: 'dictionaries.platform.verdinhabet', isActive: 0 },
        { id: Platform.Oddjusta, name: 'dictionaries.platform.oddjusta', isActive: 1 },
        { id: Platform.Matchbook, name: 'dictionaries.platform.matchbook', isActive: 1 },
        { id: Platform.Oddrs, name: 'dictionaries.platform.oddrs', isActive: 1 },
    ],
    ['name', 'shortName']
);

/** Platform columns / account form checkboxes: excludes `isActive: 0`. Bets and other filters use `platformDictionary.items`. */
export function getAccountUiPlatformIds(): number[] {
    return platformDictionary.items.filter((p) => p.isActive !== 0).map((p) => Number(p.id));
}
